import type { SSData } from 'glov/client/soundscape.js';

export const SOUNDSCAPE_DATA: SSData = {
  base_path: 'soundscape/',
  default_fade_time: 3000,
  layers: {
    bgThirdMaster: {
      excl_group_master: true,
      odds: [0,1],
      period: 17142,
      min_intensity: 0.01,
      files: [
        { file: 'bgThird_woods_air_a', excl_group: 'F' },
        { file: 'bgThird_woods_air_a', excl_group: 'Flyd' },
        { file: 'bgThird_woods_air_f', excl_group: 'Dm' }, // Save minor for at night?
        { file: 'bgThird_woods_air_f', excl_group: 'DpedEm' },
        { file: 'bgThird_woods_air_gb', excl_group: 'D' },
        { file: 'bgThird_woods_air_d', excl_group: 'Bb' },
        { file: 'bgThird_woods_air_e', excl_group: 'DpedC' },
        // { file: 'bgThird_woods_air_e', excl_group: 'DpedC1' },
        // { file: 'bgThird_woods_air_e', excl_group: 'DpedC2' },
      ],
      tags: {
        home: {
          priority: 1,
          files: [
            { file: 'bass_whaledrum_motif_g_tag-home', excl_group: 'G' },
            { file: 'bass_whaledrum_motif_g_tag-home', excl_group: 'Gm' },
            { file: 'bass_whaledrum_motif_g_tag-home', excl_group: 'Gped' },
          ],
        },
        night: {
          priority: 0.9,
          files: [
            // { file: 'bgThird_piano_e', excl_group: 'DpedC' },
            // { file: 'bgThird_piano_f', excl_group: 'Dm' },
            // { file: 'bgThird_piano_d', excl_group: 'Bb' },
            // { file: 'bgThird_piano_A', excl_group: 'F' },

            { file: 'bgThird_woods_echo_e', excl_group: 'DpedC' },
            { file: 'bgThird_woods_echo_f', excl_group: 'Dm' },
            { file: 'bgThird_woods_echo_d', excl_group: 'Bb' },
            { file: 'bgThird_woods_echo_d3', excl_group: 'Bb' },
            { file: 'bgThird_woods_echo_a', excl_group: 'F' },
            { file: 'bgThird_woods_echo_Bb', excl_group: 'Gm' },

            // { file: 'bgThird_piano_g', excl_group: 'FpedEb' },
            // { file: 'bgThird_piano_g', excl_group: 'DpedEm' },
            // { file: 'bgThird_piano_Ab', excl_group: 'Fm' },
            // { file: 'bgThird_piano_g', excl_group: 'FpedEb' },
            // { file: 'bgThird_piano_bb', excl_group: 'Gm' },
            // { file: 'bgThird_piano_bb', excl_group: 'FpedGm' },
            // { file: 'bgThird_piano_B', excl_group: 'G' },
          ],
        },
        snow: {
          priority: 0.8,
          files: [
            //{ file: 'bgThird_piano_f', excl_group: 'Dm' },
            //{ file: 'bgThird_piano_g', excl_group: 'Em' },
            //{ file: 'bgThird_piano_Ab', excl_group: 'Fm' },
            //{ file: 'bgThird_piano_bb', excl_group: 'Gm' },

            { file: 'bgThird_piano_d', excl_group: 'Bb' },
            { file: 'bgThird_piano_Gb', excl_group: 'D' },
            { file: 'bgThird_piano_g', excl_group: 'DpedEm' },
            { file: 'bgThird_piano_e', excl_group: 'DpedC' },
            { file: 'bgThird_piano_A', excl_group: 'F' },
            { file: 'bgThird_piano_B', excl_group: 'Flyd' },
            { file: 'bgThird_piano_g', excl_group: 'FpedEb' },
            { file: 'bgThird_piano_bb', excl_group: 'FpedGm' },
            { file: 'bgThird_piano_B', excl_group: 'G' },
            { file: 'bgThird_piano_A', excl_group: 'Gped' },
          ],
        },
        underground: {
          priority: 1,
          period: 8571,
          files: [
            { file: 'bg_sync_underground_air_d', excl_group: 'D' },
            { file: 'bg_sync_underground_air_d_rr2', excl_group: 'D' },
            { file: 'bg_sync_underground_air_d', excl_group: 'DpedC' },
            { file: 'bg_sync_underground_air_d_rr2', excl_group: 'DpedC' },
            { file: 'bg_sync_underground_air_d', excl_group: 'Dm' },
            { file: 'bg_sync_underground_air_d', excl_group: 'G' },
            { file: 'bg_sync_underground_air_d', excl_group: 'Gm' },
            { file: 'bg_sync_underground_air_d_rr2', excl_group: 'Gm' },
          ],
        },
        underwater: {
          priority: 1,
          odds: [0,1],
          period: 24000,
          files: [
            { file: 'uw_color_harp_daDbe', excl_group: 'D' },
            { file: 'uw_color_harp_daDbe', excl_group: 'A' },
            { file: 'uw_color_harp_daDbe', excl_group: 'ApedG' },
            { file: 'uw_color_harp_daDbe', excl_group: 'G' },
            { file: 'uw_color_harp_daDbe', excl_group: 'Bdim' },
            { file: 'uw_color_harp_dace', excl_group: 'GpedF' },
            { file: 'uw_color_harp_dace', excl_group: 'Dm' },
            { file: 'uw_color_harp_dace', excl_group: 'F' },
            { file: 'uw_color_harp_dace', excl_group: 'Bbmaj7' },
            { file: 'uw_color_harp_dace', excl_group: 'Am' },
            { file: 'uw_color_harp_daDbe-2', excl_group: 'D' },
            { file: 'uw_color_harp_daDbe-2', excl_group: 'A' },
            { file: 'uw_color_harp_daDbe-2', excl_group: 'ApedG' },
            { file: 'uw_color_harp_daDbe-2', excl_group: 'G' },
            { file: 'uw_color_harp_daDbe-2', excl_group: 'Bdim' },
            { file: 'uw_color_harp_dace-2', excl_group: 'GpedF' },
            { file: 'uw_color_harp_dace-2', excl_group: 'Dm' },
            { file: 'uw_color_harp_dace-2', excl_group: 'F' },
            { file: 'uw_color_harp_dace-2', excl_group: 'Bbmaj7' },
            { file: 'uw_color_harp_dace-2', excl_group: 'Am' },
          ],
        },
      },
    },
    glue: {
      min_intensity: 0.1,
      odds: [0,1],
      files: [],
      tags: {
        underwater: {
        //  sync_with: 'bgThirdMaster',
          odds: [0,1],
          period: 24000,
          min_intensity: 0.1,
          priority: 1,
          files: [
            { file: 'uw_glue_pad_Am', excl_group: ['Am','Cmaj7'] },
            { file: 'uw_glue_pad_A', excl_group: ['A'] },
            { file: 'uw_glue_pad_Bb', excl_group: ['Bb', 'Gm','Bbmaj7'] },
            { file: 'uw_glue_pad_Bdim', excl_group: ['Bdim'] },
            { file: 'uw_glue_pad_C', excl_group: ['C','CpedBb'] },
            { file: 'uw_glue_pad_D', excl_group: ['D','DpedC'] },
            { file: 'uw_glue_pad_Dm', excl_group: ['Dm'] },
            { file: 'uw_glue_pad_Em', excl_group: ['Em','Cmaj7'] },
            { file: 'uw_glue_pad_F', excl_group: ['F','GpedF'] },
            { file: 'uw_glue_pad_G', excl_group: ['G', 'ApedG', 'Em'] },
          ],
        },
      },
    },
    colorLowHarps: {
      odds: [5,3,4],
      period: 6000,
      period_noise: 2000,
      min_intensity: 0.05,
      add_delay: 3000,
      files: [
        { file: 'bgColor_harps_pp_bb4', excl_group: ['Bb'] },
        { file: 'bgColor_harps_pp_a4', excl_group: ['Dm','D','F'] },
        { file: 'bgColor_harps_pp_f4', excl_group: ['Dm','F','Flyd','Bb'] },
        { file: 'bgColor_harps_pp_d4', excl_group: ['Dm','D','Flyd','G','Gm'] },
        { file: 'bgColor_harps_pp_bb3', excl_group: ['Bb'] },
        { file: 'bgColor_harps_pp_a3', excl_group: ['Dm','D','F'] },
      ],
      tags: {
        night: {
          priority: 1,
          odds: [2,1],
          min_intensity: 0.05,
          //max_intensity: 0.7,
          files: [
            { file: 'color_night_guitar_thirds_GBb', excl_group: ['Gm', 'FpedEb'] },
            { file: 'color_night_guitar_thirds_Gb', excl_group: ['G','Em','ApedG'] },
            { file: 'color_night_guitar_thirds_Ebg', excl_group: ['Cm','FpedEb'] },
            { file: 'color_night_guitar_thirds_ce', excl_group: ['DpedC','Am'] },
            { file: 'color_night_guitar_thirds_FAb', excl_group: ['Fm', 'Db'] },
            { file: 'color_night_guitar_thirds_Fa', excl_group: ['Dm','F', 'Gped'] },
            { file: 'color_night_guitar_thirds_Bbd', excl_group: ['Bb', 'Gm', 'FpedEb'] },
            { file: 'color_night_guitar_thirds_df', excl_group: ['Dm','Bb','Bbmaj7','Fm'] },
          ],
        },
        snow: {
          priority: 0.9,
          odds: [0,3,2,1],
          files: [
            { file: 'bgColor_harps_pp_bb4', excl_group: ['Bb', 'Gm', 'FpedEb'] },
            { file: 'bgColor_harps_pp_a4', excl_group: ['Dm','D','F'] },
            { file: 'bgColor_harps_pp_f4', excl_group: ['Dm','F','Flyd','Bb', 'FpedEb'] },
            { file: 'bgColor_harps_pp_d4', excl_group: ['Dm','D','Flyd','G','Gm'] },
            { file: 'bgColor_harps_pp_bb3', excl_group: ['Bb', 'Gm', 'FpedEb'] },
            { file: 'bgColor_harps_pp_a3', excl_group: ['Dm','D','F', 'Gped'] },
          ],
        },
        underwater: {
          priority: 0.95,
          min_intensity: 0.25,
          odds: [4,1],
          period: 12000,
          files: [
            { file: 'uw_chords_str_tides_A', excl_group: ['A', 'D', 'ApedG'] },
            { file: 'uw_chords_str_tides_Bdim', excl_group: ['Bdim','G'] },
            { file: 'uw_chords_str_tides_Bm7', excl_group: ['Bm','G'] },
            { file: 'uw_chords_str_tides_D', excl_group: ['D'] },
            { file: 'uw_chords_str_tides_Dm', excl_group: ['Dm'] },
            { file: 'uw_chords_str_tides_F', excl_group: ['F'] },
            { file: 'uw_chords_str_tides_G', excl_group: ['G','GpedF', 'ApedG', 'Em'] },
            { file: 'uw_chords_str_tides_Gmaj7', excl_group: ['G','GpedF','Em'] },
          ],
        },
      },
    },
    bg: {
      max: 3,
      //odds: [0,1,2,4],
      period: 10000,
      period_noise: 5000,
      min_intensity: 0.08,
      add_delay: 2000,
      files: [
        { file: 'bg_strings_p_a3', excl_group: ['Dm','D','F'] },
        { file: 'bg_strings_p_b3', excl_group: ['DpedEm','DpedC1'] },
        { file: 'bg_strings_p_c4', excl_group: ['F','DpedC'] },
        { file: 'bg_strings_p_g3', excl_group: ['F','DpedC','DpedEm'] },
        { file: 'bg_strings_p_g4', excl_group: ['F','DpedC','DpedEm'] }, // Check
        { file: 'bg_strings_p_d4', excl_group: ['Dm','D'] },
        { file: 'bg_strings_p_aba4', excl_group: 'Flyd' },
        { file: 'bg_strings_p_Bb3', excl_group: ['Gm','FpedEb'] },
        { file: 'bg_strings_p_Eb4', excl_group: ['FpedEb','Fm'] },
        { file: 'bg_horn_swell_aba3', excl_group: 'Flyd' },
        { file: 'bg_horn_swell_a3', excl_group: ['Dm','F'] },
        { file: 'bg_strings_p_adlib_swells_a3', excl_group: ['Dm','D','F','Bb'] }
      ],
      tags: {
        snow: {
          priority: 0.9,
          files: [
            { file: 'bg_snow_strings_p_a5', excl_group: ['Dm','D','F'] },
            { file: 'bg_snow_strings_p_b5', excl_group: ['DpedEm','DpedC'] },
            { file: 'bg_snow_strings_p_c6', excl_group: ['F','DpedC'] },
            { file: 'bg_snow_strings_p_g5', excl_group: ['F','DpedC','DpedEm'] },
            { file: 'bg_snow_strings_p_g6', excl_group: ['F','DpedC','DpedEm'] },
            { file: 'bg_snow_strings_p_d6', excl_group: ['Dm','D'] },
            { file: 'bg_snow_strings_p_aba6', excl_group: 'Flyd' },
          ],
        },
        night: {
          priority: 1,
          files: [
            // { file: 'bg_strings_p_a3', excl_group: ['Dm','D','F'] },
            // { file: 'bg_strings_p_b3', excl_group: ['DpedEm','DpedC1'] },
            // { file: 'bg_strings_p_c4', excl_group: ['F','DpedC'] },
            // { file: 'bg_strings_p_g3', excl_group: ['F','DpedC','DpedEm'] },
            // { file: 'bg_strings_p_g4', excl_group: ['F','DpedC','DpedEm'] }, // Check
            // { file: 'bg_strings_p_Bb3', excl_group: ['Gm','FpedEb'] },
            // { file: 'bg_strings_p_Eb4', excl_group: ['FpedEb','Fm'] },
            // { file: 'bg_strings_p_d4', excl_group: ['Dm','D'] },
            // { file: 'bg_strings_p_aba4', excl_group: 'Flyd' },
            // { file: 'bg_strings_p_adlib_swells_a3', excl_group: ['Dm','D','F','Bb'] }
            { file: 'bg_harps_p_e4', excl_group: 'DpedC' },
            { file: 'bg_harps_p_f4', excl_group: ['Dm','F','Fm'] },
            { file: 'bg_harps_p_f3', excl_group: ['Dm','F','Fm'] },
            { file: 'bg_harps_p_d4', excl_group: ['Bb','D','Dm'] },
            { file: 'bg_harps_p_a3', excl_group: ['F'] },
            { file: 'bg_harps_p_Bb3', excl_group: ['Gm', 'Bb'] },

            { file: 'bg_harps_p_g4', excl_group: ['Gm','G','DpedC'] },
            { file: 'bg_harps_p_g3', excl_group: ['Gm','G','DpedC'] },
            { file: 'bg_harps_p_c4', excl_group: ['DpedC'] },
            { file: 'bg_harps_p_b3', excl_group: ['G', 'FpedEb'] },

          ],
        },
        underground: {
          priority: 1,
          period: 8571,
          odds: [3,1],
          files: [
            { file: 'bg_underground_air_c', excl_group: ['D'] },
            { file: 'bg_underground_air_b', excl_group: ['D', 'G'] },
            { file: 'bg_underground_air_Gb', excl_group: ['D'] },
          ],
        },
        underwater: {
          min_intensity: 0.4,
          priority: 1,
          sync_with: 'bgThirdMaster',
          odds: [3,1],
          files: [
            { file: 'bg_strings_p_a3', excl_group: ['Dm','D','F', 'ApedG', 'Am', 'A'] },
            { file: 'bg_strings_p_b3', excl_group: ['DpedEm','DpedC1','Bm','Bdim','G','ApedG'] },
            { file: 'bg_strings_p_c4', excl_group: ['F','DpedC'] },
            { file: 'bg_strings_p_g3', excl_group: ['F','DpedC','DpedEm','ApedG','GpedF'] },
            //{ file: 'bg_strings_p_g4', excl_group: ['F','DpedC','DpedEm','ApedG','GpedF'] }, // Check
            //{ file: 'bg_strings_p_d4', excl_group: ['Dm','D','Bm','Bdim',''] },
            { file: 'bg_strings_p_aba4', excl_group: 'Flyd' },
            { file: 'bg_strings_p_Bb3', excl_group: ['Gm','FpedEb'] },
            { file: 'bg_strings_p_Eb4', excl_group: ['FpedEb','Fm'] },
            // { file: 'bg_strings_p_adlib_swells_a3', excl_group: ['Dm','D','F','Bb','Am','A','ApedG'] }
          ],
        },
      },
    },
    bgSync: {
      //max: 1,
      sync_with: 'bgThirdMaster',
      odds: [1,2],
      // period: 34285, // 4 measures = 34285
      // period_noise: 10000,
      min_intensity: 0.15,
      add_delay: 5000,
      files: [
        { file: 'bg_harp_celesta_low', excl_group: ['Dm', 'F'] },
        { file: 'bg_harp_celesta_low2', excl_group: ['Dm', 'F'] },
        { file: 'bg_harp_celesta_lowest', excl_group: ['Dm', 'F', 'Bb'] },
        { file: 'bg_harp_celesta_low_dped', excl_group: ['DpedC'] },
        { file: 'bg_felt_celesta_low1', excl_group: ['Dm', 'F'] },
        { file: 'bg_felt_celesta_low2', excl_group: 'D' },
        { file: 'bg_felt_celesta_low3', excl_group: ['F', 'Dm', 'Bb'] },
        { file: 'color_harp_p_Dmaj', excl_group: ['D', 'Bb'] },
        { file: 'color_harp_p_gfd', excl_group: ['F', 'Dm', 'Bb', 'G'] },
      ],
      tags: {
        home: {
          priority: 1,
          files: [
            { file: 'bg_sync_phrase_gdcbfa_4-4_tag-home', excl_group: ['G','Gped'] },
          ],
        },
        snow: { // Todo: Snow night and snow day different through day&night tags on bgThird master.
          priority: 0.9,
          odds: [0,1],
          files: [
            { file: 'bg_sync_guitar_shimmer_abd', excl_group: ['Em','DpedEm','Dm','D','G'] },
            { file: 'bg_sync_guitar_shimmer_cdf', excl_group: ['Dm','F','Fm','FpedEb','FpedGm', 'Gm', 'Bb'] },
            { file: 'bg_sync_guitar_shimmer_gac', excl_group: ['DpedC','F'] },
          ],
        },
        night: {
          priority: 0.95,
          files: [
          ],
        },
        underground: {
          priority: 0.99,
          files: [],
        },
        underwater: {
          priority: 1,
          odds: [0,1],
          files: [ // Moved to colorRandom
            // { file: 'uw_color_piano_ae', excl_group: ['D','Dm','F','GpedF','G','A','Bm','Bdim'] },
            // { file: 'uw_color_piano_gd', excl_group: ['Dm','Em','F','ApedG','G','Bb','C'] },
          ],
        },
      },
    },
    bgThirdBrass: {
      sync_with: 'bgThirdMaster',
      odds: [1,1],
      period: 26000,
      period_noise: 5000,
      min_intensity: 0.25,
      files: [
        { file: 'bgThird_trombone_mp_gb3', excl_group: 'D' },
        { file: 'bgThird_trombone_mp_a2', excl_group: ['Dm','F'] },
        { file: 'bgThird_trombone_mp_a3', excl_group: ['Dm','D','F'] },
        { file: 'bgThird_trombone_mp_f3g3', excl_group: ['F', 'Bb'] },
        { file: 'bgThird_trombone_mp_f3', excl_group: ['Dm', 'F', 'Bb'] },
        { file: 'bgThird_trombone_mp_f-e', excl_group: ['Dm','F'] },
        { file: 'bgThird_trombone_mp_f4', excl_group: ['Dm','F', 'Bb'] },
        { file: 'bgThird_trombone_mp_e4', excl_group: ['DpedC'] },
        { file: 'bgThird_trombone_mp_e3', excl_group: ['DpedEm'] },
      ],
      tags: {
        night: {
          priority: 1,
          files: []
        },
        snow: {
          priority: 1,
          files: []
        },
        underground: {
          priority: 1,
          files: [],
        },
        underwater: {
          priority: 1,
          files: [],
        },
      },
    },
    bassLow: {
      odds: [0,1],
      sync_with: 'bgSync',
      min_intensity: 0.2,
      max_intensity: 0.6,
      files: [
        { file: 'bass_strings_5ths_p_f', excl_group: ['F','Flyd'] },
        { file: 'bass_strings_5ths_p_d', excl_group: ['D', 'Dm'] },
        { file: 'bass_str_bassoon_f', excl_group: ['F','Flyd'] },
        { file: 'bass_str_bassoon_d', excl_group: ['D', 'Dm', 'DpedC','DpedEm'] },
        { file: 'bass_str_bassoon_g', excl_group: ['G', 'Gm'] },
        { file: 'bass_str_bassoon_Bb', excl_group: ['Bb', 'Dm'] },
        { file: 'bass_strings_p_f', excl_group: ['F','Flyd'] },
        { file: 'bass_strings_p_d', excl_group: ['D', 'Dm', 'DpedC','DpedEm'] },
        { file: 'bass_strings_p_bb', excl_group: ['Dm', 'F', 'Bb'] },
      ],
      tags: {
        home: {
          priority: 0.99,
          odds: [1,1],
          files: [
          ],
        },
        night: {
          sync_with: 'bgThirdMaster',
          priority: 0.8,
          min_intensity: 0.25,
          max_intensity: 0.5,
          add_delay: 5200,
          files: [
            { file: 'bass_pizz_soft_bs_cel_Dm', excl_group: ['Dm'] },
            { file: 'bass_pizz_soft_bs_cel_D5', excl_group: ['Dm', 'D', 'DpedC'] },
            { file: 'bass_pizz_soft_bs_cel_F5', excl_group: ['Fm', 'FpedEb', 'F'] },
            { file: 'bass_pizz_soft_bs_cel_Gm', excl_group: ['Gm'] },
            { file: 'bass_pizz_soft_bs_cel_Bb5', excl_group: ['Dm', 'Bb'] },
            { file: 'bass_pizz_soft_bs_cel_GmDesc', excl_group: ['Gm', 'Bb'] },
          ],
        },
        snow: {
          priority: 0.7,
          odds: [0,1],
          //sync_with: 'bgSync',
          files: [
            { file: 'bassLow_snow_piano_str_hp_G', excl_group: ['G','Gped','Gm'] },
            { file: 'bassLow_snow_piano_str_hp_F', excl_group: ['F','Flyd','FpedEb'] },
            { file: 'bassLow_snow_piano_str_hp_D', excl_group: ['D','DpedC','DpedEm'] },
            { file: 'bassLow_snow_piano_str_hp_Bb', excl_group: ['Bb'] },
          ],
        },
        underground: {
          priority: 0.9,
          sync_with: 'bgThirdMaster',
          odds: [1,1],
          files: [
            { file: 'bass_ug_whale_ppiano_phrase_g', excl_group: ['G','Gm', 'Gped'] },
            { file: 'bass_ug_whale_ppiano_phrase_f', excl_group: ['F','Flyd','FpedEb'] },
            { file: 'bass_ug_whale_ppiano_phrase_d', excl_group: ['D','DpedC','DpedEm'] },
            { file: 'bass_ug_whale_ppiano_phrase_Bb', excl_group: ['Bb'] },
          ],
        },
        // underwater: {
        //   priority: 1,
        //   sync_with: 'bgThirdMaster',
        //   odds: [0,1],
        //   files: [
        //     { file: 'uw_bass_a1', excl_group: ['Am', 'A','ApedG', 'Dm'] },
        //     { file: 'uw_bass_b1', excl_group: ['Dm','Bdim','Bm'] },
        //     { file: 'uw_bass_d1', excl_group: ['D','Dm','F','G'] },
        //     { file: 'uw_bass_d2', excl_group: ['D','Dm','F','G'] },
        //     { file: 'uw_bass_f1', excl_group: ['F','GpedF','Am', 'Dm'] },
        //     { file: 'uw_bass_g1', excl_group: ['G', 'Gm', 'ApedG'] },
        //   ],
        // },
        // uw_bass_a1
        // uw_bass_b1
        // uw_bass_d1
        // uw_bass_d2
        // uw_bass_f1
        // uw_bass_g1
      },
    },
    bassUW: {
      odds: [0,1],
      files: [],
      min_intensity: 0.4,
      tags: {
        underwater: {
          priority: 1,
          //sync_with: 'bgThirdMaster',
          period: 11268,
          odds: [0,1],
          files: [
            { file: 'uw_bass_a1', excl_group: ['Am', 'A','ApedG', 'Dm'] },
            { file: 'uw_bass_b1', excl_group: ['Bdim','Bm'] }, // Dm works but happens too often
            { file: 'uw_bass_bb1', excl_group: ['Bb','Gm','CpedBb'] },
            { file: 'uw_bass_d1', excl_group: ['D','Dm','F','G'] },
            { file: 'uw_bass_d2', excl_group: ['D','Dm','F','G'] },
            { file: 'uw_bass_f1', excl_group: ['F','GpedF','Am', 'Dm'] },
            { file: 'uw_bass_g1', excl_group: ['G', 'Gm', 'ApedG'] },
          ],
        },
      },
    },
    bass: {
      odds: [0,1],
      // period: 20000,
      // period_noise: 10000,
      sync_with: 'bgThirdMaster',
      min_intensity: 0.6,
      files: [
        { file: 'bass_strings_5ths_p_f', excl_group: ['F','Flyd'] },
        { file: 'bass_strings_5ths_p_d', excl_group: ['D', 'Dm'] },
        { file: 'bass_str_bassoon_f', excl_group: ['F','Flyd','Fm'] },
        { file: 'bass_str_bassoon_d', excl_group: ['D', 'Dm', 'DpedC', 'DpedEm'] },
        { file: 'bass_strings_p_f', excl_group: ['F','Flyd'] },
        { file: 'bass_strings_p_d', excl_group: ['D', 'Dm', 'DpedC','DpedEm'] },
        { file: 'bass_strings_p_bb', excl_group: ['Dm', 'F', 'Bb'] },
        { file: 'bass_strings_p_g', excl_group: ['Gm', 'G'] },
      ],
      tags: {
        night: {
          priority: 0.9,
          min_intensity: 0.5,
          files: [
            { file: 'bass_strings_p_d', excl_group: ['D', 'Dm', 'DpedC','DpedEm'] },
            { file: 'bass_strings_p_f', excl_group: ['Fm', 'FpedEb'] },
            { file: 'bass_strings_p_bb', excl_group: ['Dm', 'Bb'] },
            { file: 'bass_strings_p_g', excl_group: ['Gm', 'G'] },
          ]
        },
        underground: {
          priority: 1,
          files: [
            { file: 'bass_str_bassoon_f', excl_group: ['F','Flyd','Fm','FpedEb'] },
            { file: 'bass_str_bassoon_d', excl_group: ['D', 'Dm', 'DpedC','DpedEm'] },
            { file: 'bass_str_bassoon_g', excl_group: ['G','Gm'] },
            { file: 'bass_str_bassoon_Bb', excl_group: ['Bb'] },
          ],
        },
        underwater: {
          priority: 1,
          files: [],
        },
      },
    },
    colorLowWoods: {
      odds: [3,1],
      period: 45000,
      period_noise: 5000,
      min_intensity: 0.3,
      max_intensity: 0.6,
      add_delay: 3000,
      files: [
        { file: 'bgWoods_trills_p_ab', excl_group: 'Flyd' },
        { file: 'bgWoods_trills_p_dea', excl_group: ['D','Dm','F'] },
        { file: 'bgWoods_trills_p_fgc', excl_group: ['Dm','F'] },
        { file: 'bgWoods_trills_p_fd5', excl_group: ['Dm','F'] },
        { file: 'bgWoods_trills_p_fd4', excl_group: ['Dm','F'] },
        { file: 'bgWoods_trills_p_fa', excl_group: ['Dm','F', 'Bb'] },
        { file: 'bgWoods_trills_p_ac', excl_group: ['D','Dm','F','Bb'] },
      ],
      tags: {
        night: {
          priority: 1,
          files: []
        },
        underground: {
          priority: 1,
          files: [],
        },
        underwater: {
          priority: 1,
          files: [],
        },
      },
    },
    colorRandom: {
      odds: [1,1],
      period: 17142,
      period_noise: 8571,
      min_intensity: 0.2,
      files: [],
      tags: {
        night: {
          priority: 1,
          odds: [5,1],
          min_intensity: 0.3,
          max_intensity: 0.5,
          files: [
            // { file: 'colorRandom_night_marimba_phrase_ec', excl_group: ['D','G','Gm'] },
            // { file: 'colorRandom_night_marimba_phrase_ad', excl_group: ['Gm','G'] },
            // { file: 'colorRandom_night_marimba_phrase_cg', excl_group: ['DpedC','Bb','F','FpedEb'] },
            // //{ file: 'colorRandom_night_marimba_phrase_cAbg', excl_group: ['Fm'] },
            // { file: 'colorRandom_night_marimba_phrase_cfg', excl_group: ['Dm', 'F','FpedGm','Gm','Bb'] },
            // {
            //   file: 'colorRandom_night_marimba_phrase_dga',
            //   excl_group: ['D','Dm','Bb','DpedC','G','Gm','Gped','F','Flyd']
            // },
          ]
        },
        underground: {
          priority: 1,
          files: [
            { file: 'color_underground_harp_celeste_G', excl_group: ['G','Gm'] },
            { file: 'color_underground_harp_celeste_Gb4', excl_group: ['D'] },
            { file: 'color_underground_harp_celeste_f4', excl_group: ['Dm','D'] },
            { file: 'color_underground_harp_celeste_e4', excl_group: ['G','D','Gm'] },
            { file: 'color_underground_harp_celeste_d4', excl_group: ['D','G','Gm'] },
            { file: 'color_underground_harp_celeste_C4', excl_group: ['D'] },
            { file: 'color_underground_harp_celeste_b3', excl_group: ['D','G'] },
            { file: 'color_underground_harp_celeste_Bb3', excl_group: ['Bb','Gm'] },
            { file: 'color_underground_harp_celeste_a3', excl_group: ['D','G','Gm'] },
            { file: 'color_underground_harp_celeste_g3', excl_group: ['Gm','G'] },
            { file: 'color_underground_harp_celeste_gb3', excl_group: ['D'] },
            { file: 'color_underground_harp_celeste_f3', excl_group: ['Dm','G'] },
            { file: 'color_underground_harp_celeste_e3', excl_group: ['G','D','Gm'] },
            { file: 'color_underground_harp_celeste_d3', excl_group: ['D','G','Gm'] },
          ],
        },
        underwater: { // TEST
          priority: 1,
          odds: [1,1],
          max_intensity: 0.69,
          files: [
            { file: 'uw_color_piano_ae', excl_group: ['D','Dm','F','GpedF','G','A','Bm','Bdim'] },
            { file: 'uw_color_piano_gd', excl_group: ['Dm','Em','F','ApedG','G','Bb','C'] },
          ],
        },
      },
    },
    colorRandomHi: {
      odds: [1,1],
      period: 17142,
      min_intensity: 0.699,
      files: [],
      tags: {
        night: {
          priority: 1,
          odds: [5,1],
          min_intensity: 0.3,
          max_intensity: 0.5,
          files: []
        },
        underground: {
          priority: 1,
          files: [

          ],
        },
        underwater: {
          priority: 1,
          odds: [1,1],
          period: 12000,
          files: [
            { file: 'color_underground_harp_celeste_G', excl_group: ['G','Gm','GpedF'] },
            { file: 'color_underground_harp_celeste_Gb4', excl_group: ['D','Bm'] },
            { file: 'color_underground_harp_celeste_f4', excl_group: ['Dm','F','GpedF'] },
            { file: 'color_underground_harp_celeste_e4', excl_group: ['G','D','Gm','Em','C','Am','A'] },
            { file: 'color_underground_harp_celeste_d4', excl_group: ['D','G','Gm','Dm','ApedG'] },
            { file: 'color_underground_harp_celeste_C4', excl_group: ['C','Bb','Bbmaj7'] },
            { file: 'color_underground_harp_celeste_b3', excl_group: ['D','G','Bm','Bdim'] },
            { file: 'color_underground_harp_celeste_Bb3', excl_group: ['Bb','Gm','Bbmaj7'] },
            { file: 'color_underground_harp_celeste_a3', excl_group: ['D','G','Gm','Bbmaj7'] },
            { file: 'color_underground_harp_celeste_g3', excl_group: ['Gm','G','Em','GpedF'] },
            { file: 'color_underground_harp_celeste_gb3', excl_group: ['D'] },
            { file: 'color_underground_harp_celeste_f3', excl_group: ['Dm','G','F','GpedF'] },
            { file: 'color_underground_harp_celeste_e3', excl_group: ['G','D','Gm','Em'] },
            { file: 'color_underground_harp_celeste_d3', excl_group: ['D','G','Gm','Bm','Bdim'] },
          ],
        },
      },
    },
    colorSync: {
      odds: [3,1],
      min_intensity: 0.5,
      sync_with: 'bgThirdMaster',
      files: [
        { file: 'color_glock_p_Dmaj', excl_group: ['D'] },
        { file: 'color_glock_p_cda6', excl_group: ['Dm', 'F', 'Bb'] },
        { file: 'color_glock_p_cda5', excl_group: ['Dm', 'F', 'Bb'] },
      ],
      tags: {
        night: {
          priority: 0.8,
          odds: [1,1],
          min_intensity: 0.1,
          max_intensity: 0.25,
          files: [
            { file: 'fg_night_flute_phrase3', excl_group: ['Dm','Bb', 'Gm', 'DpedC'] },
            { file: 'fg_night_flute_phrase2', excl_group: ['Dm','Bb', 'Gm', 'DpedC'] },
            { file: 'fg_night_flute_phrase1', excl_group: ['Dm','Bb', 'Gm', 'DpedC'] },
            { file: 'fg_night_flute_phrase4', excl_group: ['Dm','Bb', 'Gm', 'DpedC'] },
          ],
        },
        snow: {
          odds: [0,1],
          priority: 0.9,
          files: [
            { file: 'bg_snow_celeste_Bbmaj', excl_group: ['Bb'] },
            { file: 'bg_snow_celeste_D', excl_group: ['D'] },
            { file: 'bg_snow_celeste_Dm', excl_group: ['Dm','F','Bb'] },
            { file: 'bg_snow_celeste_DpedC', excl_group: ['DpedC'] },
            { file: 'bg_snow_celeste_Em', excl_group: ['Em','G'] },
            { file: 'bg_snow_celeste_F', excl_group: ['Dm','F','Bb'] },
            { file: 'bg_snow_celeste_Flyd', excl_group: ['Flyd'] },
            { file: 'bg_snow_celeste_Fm', excl_group: ['Fm'] },
            { file: 'bg_snow_celeste_Fped', excl_group: ['FpedEb'] },
            { file: 'bg_snow_celeste_G', excl_group: ['G'] },
            { file: 'bg_snow_celeste_Gped', excl_group: ['Gped'] },
            { file: 'bg_snow_celeste_Gm', excl_group: ['Gm', 'Bb'] },
            // { file: 'bg_sync_snow_marimba_cdf', excl_group: ['Fm','FpedGm','Dm','Bb'] },
            // { file: 'bg_sync_snow_marimba_aed', excl_group: ['Dm','DpedEm','FpedGm'] },
          ],
        },
        underground: {
          priority: 0.95,
          odds: [0,1],
          files: [
            { file: 'color_sync_third_underground_stutters_e3', excl_group: ['DpedC'] },
            { file: 'color_sync_third_underground_stutters_b3', excl_group: ['G', 'Dm', 'D'] },
            { file: 'color_sync_third_underground_stutters_Bb3', excl_group: ['Gm'] },
            { file: 'color_sync_third_underground_stutters_Gb3', excl_group: ['D'] },
            { file: 'color_sync_third_underground_stutters_f3', excl_group: ['Dm'] },
          ],
        },
        underwater: {
          priority: 1,
          files: [],
        },
      }
    },
    fgLo: {
      odds: [4,2],
      period: 30000,
      sync_with: 'bgThirdMaster',
      period_noise: 10000,
      min_intensity: 0.3,
      max_intensity: 0.6,
      files: [
        // { file: 'fg_felt_phrase_fga1', excl_group: ['Dm', 'F', 'Bb']},
        // { file: 'fg_felt_phrase_fgacde1', excl_group: ['Dm', 'F', 'Bb']},
        // { file: 'fg_eh_phrase_Dm_1', excl_group: 'Dm'},
        // { file: 'fg_eh_phrase_D_1', excl_group: 'D'},
        // { file: 'fg_fl_phrase_Dm_1', excl_group: 'Dm'},
        // { file: 'fg_fl_phrase_D_1', excl_group: 'D'},
        { file: 'fg_eh_phrase1_mp_dfa', excl_group: ['Dm','Bb', 'F'] },
        //{ file: 'fg_eh_phrase1_mp_egb', excl_group: [] },
        { file: 'fg_eh_phrase1_mp_fac', excl_group: ['Dm','F','Bb'] },
        { file: 'fg_eh_phrase1_mp_fad', excl_group: ['Dm','F','Flyd','Bb'] },
        { file: 'fg_eh_phrase1_mp_gb-ad', excl_group: ['D'] },
        { file: 'fg_eh_phrase1_mp_ace', excl_group: ['DpedC','F'] },
      ],
      tags: {
        night: {
          priority: 1,
          odds: [5,1],
          min_intensity: 0.5,
          max_intensity: 0.7,
          files: [
            { file: 'fg_night_bassoon_phrase_gaf', excl_group: ['Dm','Bb', 'Gm', 'DpedC'] },
            { file: 'fg_night_bassoon_phrase_efd', excl_group: ['Dm', 'Gm', 'DpedC'] },
            { file: 'fg_night_bassoon_phrase_cBbc', excl_group: ['Fm','Bb'] },
            { file: 'fg_night_bassoon_phrase_aga', excl_group: ['Dm','DpedC','Bb'] },
            { file: 'fg_night_bassoon_phrase_EbdEb', excl_group: ['Fm'] },
            { file: 'fg_night_bassoon_phrase_gfg', excl_group: ['Gm','Fm'] },
          ]
        },
        snow: {
          priority: 1,
          files: []
        },
        underground: {
          priority: 1,
          odds: [8,1],
          files: [
            { file: 'fg_underground_basoon_phrase_bg', excl_group: ['G'] },
            { file: 'fg_underground_basoon_phrase_cd', excl_group: ['D'] },
            { file: 'fg_underground_basoon_phrase_ae', excl_group: ['D'] },
            { file: 'fg_underground_basoon_phrase_da', excl_group: ['D'] },
          ],
        },
        underwater: {
          odds: [0,1],
          priority: 1,
          files: [
            { file: 'uw_phrase_marimba_Dbba', excl_group: ['D','A'] },
            { file: 'uw_phrase_marimba_dDba', excl_group: ['D','A'] },
            { file: 'uw_phrase_marimba_dca', excl_group: ['Dm','G','ApedG','F', 'GpedF'] },
          ],
        },
      },
    },
    fgHi: {
      odds: [2,1],
      // period: 30000,
      sync_with: 'bgThirdMaster',
      // period_noise: 10000,
      min_intensity: 0.6,
      max_intensity: 1,
      files: [
        { file: 'fg_fh_mf_phrase_deca1', excl_group: ['Dm','Flyd','F','DpedC'] },
        { file: 'fg_fh_mf_phrase_dacg1', excl_group: ['Dm','F','Flyd','DpedC'] },
        { file: 'fg_fh_mf_phrase_dac1', excl_group: ['Dm','D','Bb','DpedC'] },
        { file: 'fg_fh_mf_phrase_dacbba1', excl_group: ['D'] }
      ],
      tags: {
        night: {
          min_intensity: 0.7,
          priority: 0.8,
          files: [
            { file: 'fg_horn_night_ac_down', excl_group: ['Dm', 'Gm', 'DpedC','F'] },
            { file: 'fg_horn_night_ad_up', excl_group: ['Dm','DpedC','Bb','F','G'] },
            { file: 'fg_horn_night_ad_down', excl_group: ['Dm','DpedC','Bb','F','G'] },
            { file: 'fg_horn_night_ae_down', excl_group: ['G','F','Dm','DpedC'] },
            { file: 'fg_horn_night_ae_up', excl_group: ['G','F','Dm','DpedC'] },
            { file: 'fg_horn_night_dg_down', excl_group: ['Gm','G','F','Bb','DpedC'] },
            { file: 'fg_horn_night_gd_up', excl_group: ['Gm','G','F','Bb','DpedC'] },
          ]
        },
        snow: {
          priority: 0.9,
          files: [
            { file: 'fg_snow_flute_phrase_cgd', excl_group: ['Bb','Flyd','F','DpedC'] },
            { file: 'fg_snow_flute_phrase_beGb', excl_group: ['D','DpedC'] },
          ],
        },
        underground: {
          priority: 1,
          odds: [8,1],
          files: [
            { file: 'fg_underground_basoon_phrase_bg', excl_group: ['G'] },
            { file: 'fg_underground_basoon_phrase_cd', excl_group: ['D'] },
            { file: 'fg_underground_basoon_phrase_ae', excl_group: ['D'] },
            { file: 'fg_underground_basoon_phrase_da', excl_group: ['D'] },
          ],
        },
        underwater: {
          priority: 1,
          odds: [1,1],
          min_intensity: 0.6,
          files: [
            { file: 'uw_choir_a-b-c-d', excl_group: ['Am','F','GpedF'] },
            { file: 'uw_choir_a-b-db-d', excl_group: ['Bdim','D','Dm'] },
            { file: 'uw_choir_b-g-d-gb-e', excl_group: ['G'] },
            { file: 'uw_choir_c-e-f-g', excl_group: ['F','GpedF','Bbmaj7'] },
            { file: 'uw_choir_db-e-gb-ab', excl_group: ['A'] }
          ],
        },
      },
    },
  },
};
